module.exports = __webpack_public_path__ + "img/news-competition.14330a1f.jpg";